// Theresa Nguyen added half yard line below 2.11.26
const yardageTitles =
  document.currentScript?.dataset.yardageTitles?.trim().toLowerCase().split(",") || [];
const fatQuarterTitle =
  document.currentScript?.dataset.fatQuarterTitle?.trim().toLowerCase();
const halfYardTitle =
  document.currentScript?.dataset.halfYardTitle?.trim().toLowerCase();
const defaultVariantId = document.currentScript?.dataset.defaultVariantId;
const formId = document.currentScript?.dataset.formId;


const productVariants = window.productVariants || [];

let defaultSelectorClone = null;


function cacheDefaultSelector() {
  const orig = document.querySelector(
    ".product-info__block-list .quantity-selector"
  );
  if (orig) defaultSelectorClone = orig.cloneNode(true);
}



function createYardageSelectorFromDefault() {
  if (!defaultSelectorClone) return null;

  const selectedVariant = getSelectedVariant();
  const minQuantityData = window.productVariantsMinQuantity || {};
  const backendMinQty = selectedVariant ? (minQuantityData[selectedVariant.id] || 1) : 1;
  const yardageMinQty = backendMinQty * 0.25; // Convert backend quarters to frontend yards

  const clonedSelector = defaultSelectorClone.cloneNode(true);
  const yardageSelector = document.createElement("div");
  yardageSelector.className = clonedSelector.className;
  for (const attr of clonedSelector.attributes) {
    if (attr.name !== "class") {
      yardageSelector.setAttribute(attr.name, attr.value);
    }
  }
  while (clonedSelector.firstChild) {
    yardageSelector.appendChild(clonedSelector.firstChild);
  }

  const input = yardageSelector.querySelector(
    'input[type="number"], input.quantity-selector__input'
  );
  if (input) {
    input.name = "yardage_quantity";
    input.inputMode = "decimal";
    input.step = "0.25";
    input.min = yardageMinQty.toString();
    input.value = yardageMinQty.toString();
    input.setAttribute("aria-label", "Change yardage");
    input.id = "yardage-input";
  }

  let hidden = yardageSelector.querySelector(
    'input[type="hidden"][name="quantity"]'
  );
  if (!hidden) {
    hidden = document.createElement("input");
    hidden.type = "hidden";
    hidden.name = "quantity";
    hidden.id = "real-quantity";
    hidden.setAttribute("form", formId);
    yardageSelector.appendChild(hidden);
  } else {
    hidden.value = backendMinQty.toString();
    hidden.id = "real-quantity";
    hidden.setAttribute("form", formId);
  }

  const buttons = yardageSelector.querySelectorAll(
    ".quantity-selector__button"
  );
  if (buttons.length === 2) {
    buttons[0].id = "decrease-yardage";
    buttons[0].disabled = false;
    buttons[1].id = "increase-yardage";
    buttons[1].disabled = false;
  }

  return yardageSelector;
}

// Theresa Nguyen added function below 2.11.26
function createHalfYardSelectorFromDefault() {
  if (!defaultSelectorClone) return null;

  const selectedVariant = getSelectedVariant();
  const minQuantityData = window.productVariantsMinQuantity || {};
  const backendMinQty = selectedVariant ? (minQuantityData[selectedVariant.id] || 1) : 1;
  const halfYardMinQty = backendMinQty * 0.5; // 0.5 yard per backend unit

  const clonedSelector = defaultSelectorClone.cloneNode(true);
  const halfYardSelector = document.createElement("div");
  halfYardSelector.className = clonedSelector.className;
  for (const attr of clonedSelector.attributes) {
    if (attr.name !== "class") {
      halfYardSelector.setAttribute(attr.name, attr.value);
    }
  }
  while (clonedSelector.firstChild) {
    halfYardSelector.appendChild(clonedSelector.firstChild);
  }

  const input = halfYardSelector.querySelector(
    'input[type="number"], input.quantity-selector__input'
  );
  if (input) {
    input.name = "half_yard_quantity";
    input.inputMode = "decimal";
    input.step = "0.5";
    input.min = halfYardMinQty.toString();
    input.value = halfYardMinQty.toString();
    input.setAttribute("aria-label", "Change yardage");
    input.id = "half-yard-input";
  }

  let hidden = halfYardSelector.querySelector(
    'input[type="hidden"][name="quantity"]'
  );
  if (!hidden) {
    hidden = document.createElement("input");
    hidden.type = "hidden";
    hidden.name = "quantity";
    hidden.id = "half-yard-real-quantity";
    hidden.setAttribute("form", formId);
    halfYardSelector.appendChild(hidden);
  } else {
    hidden.value = backendMinQty.toString();
    hidden.id = "half-yard-real-quantity";
    hidden.setAttribute("form", formId);
  }

  const buttons = halfYardSelector.querySelectorAll(".quantity-selector__button");
  if (buttons.length === 2) {
    buttons[0].id = "decrease-half-yard";
    buttons[0].disabled = false;
    buttons[1].id = "increase-half-yard";
    buttons[1].disabled = false;
  }

  return halfYardSelector;
}




function createDefaultSelector() {
  if (!defaultSelectorClone) return null;
  
  const selectedVariant = getSelectedVariant();
  const minQuantityData = window.productVariantsMinQuantity || {};
  const minQty = selectedVariant ? (minQuantityData[selectedVariant.id] || 1) : 1;
  
  const newSelector = defaultSelectorClone.cloneNode(true);
  const input = newSelector.querySelector('input[type="number"], input.quantity-selector__input');
  if (input) {
    input.min = minQty.toString();
    input.value = minQty.toString();
  }
  
  return newSelector;
}

// function updateUnitLabel(type, quantity) {
//   const container = document.querySelector(".quantity-input");
//   if (!container) return;
//   let label = container.querySelector(".quantity-unit-label");
//   if (!type) {
//     if (label) label.remove();
//     return;
//   }
//   if (!label) {
//     label = document.createElement("span");
//     label.className = "quantity-unit-label";
//     container.appendChild(label);
//   }
//   if (type === "yardage") {
//     label.textContent = quantity > 0 && quantity <= 1 ? "Yard" : "Yards";
//   } else if (type === "fat_quarter") {
//     label.textContent =
//       quantity > 0 && quantity <= 1 ? "Fat Quarter" : "Fat Quarters";
//   } 
// }
// Theresa Nguyen commented out above and added function below 2.11.26
function updateUnitLabel(type, quantity) {
  const container = document.querySelector(".quantity-input");
  if (!container) return;
  let label = container.querySelector(".quantity-unit-label");
  if (!type) {
    if (label) label.remove();
    return;
  }
  if (!label) {
    label = document.createElement("span");
    label.className = "quantity-unit-label";
    container.appendChild(label);
  }

  if (type === "yardage" || type === "half_yard") {
    label.textContent = quantity > 0 && quantity <= 1 ? "Yard" : "Yards";
  } else if (type === "fat_quarter") {
    label.textContent =
      quantity > 0 && quantity <= 1 ? "Fat Quarter" : "Fat Quarters";
  }
}




function attachYardageLogic(wrapper) {
  const yardageInput = wrapper.querySelector("#yardage-input");
  const realQuantity = wrapper.querySelector("#real-quantity");
  const increaseBtn = wrapper.querySelector("#increase-yardage");
  const decreaseBtn = wrapper.querySelector("#decrease-yardage");
  const step = 0.25;
  
  const selectedVariant = getSelectedVariant();
  const minQuantityData = window.productVariantsMinQuantity || {};
  const backendMinQty = selectedVariant ? (minQuantityData[selectedVariant.id] || 1) : 1;
  const min = backendMinQty * 0.25; // Convert backend quarters to frontend yards

  function updateRealQuantityAndLabel() {
    const yardage = parseFloat(yardageInput.value) || min;
    const quarters = Math.round(yardage / step);
    realQuantity.value = quarters;
    updateUnitLabel("yardage", yardage);
  }

  yardageInput.addEventListener("input", function () {
    let value = parseFloat(yardageInput.value) || min;
    value = Math.max(min, Math.round(value / step) * step);
    yardageInput.value = value;
    updateRealQuantityAndLabel();
    
    // Update button disabled state
    decreaseBtn.disabled = value <= min;
  });

  increaseBtn.addEventListener("click", function () {
    let value = parseFloat(yardageInput.value) || min;
    value += step;
    yardageInput.value = value;
    updateRealQuantityAndLabel();
    
    // Update button disabled state
    decreaseBtn.disabled = value <= min;
  });

  decreaseBtn.addEventListener("click", function () {
    let value = parseFloat(yardageInput.value) || min;
    value = Math.max(min, value - step);
    yardageInput.value = value;
    updateRealQuantityAndLabel();
    
    // Update button disabled state
    decreaseBtn.disabled = value <= min;
  });

  updateRealQuantityAndLabel();
  
  // Set initial button state
  decreaseBtn.disabled = parseFloat(yardageInput.value) <= min;
}

// Theresa Nguyen added function below 2.11.26
function attachHalfYardLogic(wrapper) {
  const yardageInput = wrapper.querySelector("#half-yard-input");
  const realQuantity = wrapper.querySelector("#half-yard-real-quantity");
  const increaseBtn = wrapper.querySelector("#increase-half-yard");
  const decreaseBtn = wrapper.querySelector("#decrease-half-yard");
  const step = 0.5;

  const selectedVariant = getSelectedVariant();
  const minQuantityData = window.productVariantsMinQuantity || {};
  const backendMinQty = selectedVariant ? (minQuantityData[selectedVariant.id] || 1) : 1;
  const min = backendMinQty * 0.5; // 0.5 yard per unit

  function updateRealQuantityAndLabel() {
    const yardage = parseFloat(yardageInput.value) || min;
    const units = Math.round(yardage / step); // each 0.5 yard = 1 unit
    realQuantity.value = units;
    updateUnitLabel("half_yard", yardage);
  }

  yardageInput.addEventListener("input", function () {
    let value = parseFloat(yardageInput.value) || min;
    value = Math.max(min, Math.round(value / step) * step);
    yardageInput.value = value;
    updateRealQuantityAndLabel();
    decreaseBtn.disabled = value <= min;
  });

  increaseBtn.addEventListener("click", function () {
    let value = parseFloat(yardageInput.value) || min;
    value += step;
    yardageInput.value = value;
    updateRealQuantityAndLabel();
    decreaseBtn.disabled = value <= min;
  });

  decreaseBtn.addEventListener("click", function () {
    let value = parseFloat(yardageInput.value) || min;
    value = Math.max(min, value - step);
    yardageInput.value = value;
    updateRealQuantityAndLabel();
    decreaseBtn.disabled = value <= min;
  });

  updateRealQuantityAndLabel();
  decreaseBtn.disabled = parseFloat(yardageInput.value) <= min;
}




function attachFatQuarterLabelLogic(selector) {
  const input = selector.querySelector(
    'input[type="number"], input.quantity-selector__input'
  );
  if (!input) return;
  function updateLabel() {
    const qty = parseInt(input.value, 10) || 1;
    updateUnitLabel("fat_quarter", qty);
  }
  input.addEventListener("input", updateLabel);
  input.addEventListener("change", updateLabel);
  updateLabel();
}

function getSelectedVariant() {
  let variantId = null;
  const variantInput =
    document.querySelector('input[name="id"]:checked') ||
    document.querySelector('select[name="id"]');
  if (variantInput) {
    variantId = parseInt(variantInput.value, 10);
  } else {
    const queryParams = new URLSearchParams(window.location.search);
    variantId = parseInt(queryParams.get("variant"), 10) || parseInt(defaultVariantId, 10);
  }
  return productVariants.find(v => v.id == variantId);
}

// function getSelectedVariantType() {
//   const variant = getSelectedVariant();
//   if (!variant) return null;
//   const title = variant.title.trim().toLowerCase();
//   if (yardageTitles && yardageTitles.includes(title)) return "yardage";
//   if (fatQuarterTitle && title === fatQuarterTitle) return "fat_quarter";
//   return null;
// }

// Theresa Nguyen commented out above and added function below 2.11.26
function getSelectedVariantType() {
  const variant = getSelectedVariant();
  if (!variant) return null;

  const title = variant.title.trim().toLowerCase();

  if (yardageTitles && yardageTitles.includes(title)) return "yardage";
  if (fatQuarterTitle && title === fatQuarterTitle) return "fat_quarter";
  if (halfYardTitle && title === halfYardTitle) return "half_yard";

  return null;
}




// function swapQuantitySelector(selectedType) {
//   const container = document.querySelector(
//     ".product-info__block-list .quantity-selector"
//   )?.parentNode;
//   if (!container) return;

//   const oldSelector = container.querySelector(
//     ".product-info__block-list .quantity-selector, .product-info__block-list div.quantity-selector"
//   );
//   if (oldSelector) oldSelector.remove();
//   if (selectedType !== "yardage" && selectedType !== "fat_quarter") {
//     updateUnitLabel(null);
//   }

//   let newSelector;
//   if (selectedType === "yardage") {
//     newSelector = createYardageSelectorFromDefault();
//     attachYardageLogic(newSelector);
//     updateUnitLabel(
//       "yardage",
//       parseFloat(newSelector.querySelector("#yardage-input").value)
//     );
//   } else {
//     newSelector = createDefaultSelector();
//     if (selectedType === "fat_quarter") {
//       attachFatQuarterLabelLogic(newSelector);
//     }
//   } 
//   if (newSelector) container.insertBefore(newSelector, container.firstChild);
// }
// Theresa Nguyen commented out above and added function below 2.5.26
// function swapQuantitySelector(selectedType) {
//   const container = document.querySelector(
//     ".product-info__block-list .quantity-selector"
//   )?.parentNode;
//   if (!container) return;

//   const oldSelector = container.querySelector(
//     ".product-info__block-list .quantity-selector, .product-info__block-list div.quantity-selector"
//   );
//   if (oldSelector) oldSelector.remove();

//   if (
//     selectedType !== "yardage" &&
//     selectedType !== "fat_quarter" &&
//     selectedType !== "half_yard"
//   ) {
//     updateUnitLabel(null);
//   }

//   let newSelector;
//   if (selectedType === "yardage") {
//     newSelector = createYardageSelectorFromDefault();
//     if (newSelector) {
//       attachYardageLogic(newSelector);
//       const input = newSelector.querySelector("#yardage-input");
//       if (input) {
//         updateUnitLabel("yardage", parseFloat(input.value));
//       }
//     }
//   } else if (selectedType === "half_yard") {
//     newSelector = createHalfYardSelectorFromDefault();
//     if (newSelector) {
//       attachHalfYardLogic(newSelector);
//       const input = newSelector.querySelector("#yardage-input");
//       if (input) {
//         updateUnitLabel("half_yard", parseFloat(input.value));
//       }
//     }
//   } else {
//     newSelector = createDefaultSelector();
//     if (selectedType === "fat_quarter" && newSelector) {
//       attachFatQuarterLabelLogic(newSelector);
//     }
//   }

//   if (newSelector) container.insertBefore(newSelector, container.firstChild);
// }
function swapQuantitySelector(selectedType) {
  const container = document
    .querySelector(".product-info__block-list .quantity-selector")
    ?.parentNode;
  if (!container) return;

  const oldSelector = container.querySelector(
    ".product-info__block-list .quantity-selector, .product-info__block-list div.quantity-selector"
  );
  if (oldSelector) oldSelector.remove();

  if (selectedType !== "yardage" && selectedType !== "fat_quarter" && selectedType !== "half_yard") {
    updateUnitLabel(null);
  }

  let newSelector;
  if (selectedType === "yardage") {
    newSelector = createYardageSelectorFromDefault();
    attachYardageLogic(newSelector);
    updateUnitLabel(
      "yardage",
      parseFloat(newSelector.querySelector("#yardage-input").value)
    );
  } else if (selectedType === "half_yard") {
    newSelector = createHalfYardSelectorFromDefault();
    attachHalfYardLogic(newSelector);
    updateUnitLabel(
      "half_yard",
      parseFloat(newSelector.querySelector("#half-yard-input").value)
    );
  } else {
    newSelector = createDefaultSelector();
    if (selectedType === "fat_quarter") {
      attachFatQuarterLabelLogic(newSelector);
    }
  }

  if (newSelector) container.insertBefore(newSelector, container.firstChild);
}




function onVariantChange() {
  const selectedType = getSelectedVariantType();
  swapQuantitySelector(selectedType);
}

cacheDefaultSelector();

document.body.addEventListener("change", function (e) {
  if (e.target.matches('input[name="id"], select[name="id"]')) {
    onVariantChange();
  }
});

onVariantChange();
